/**
 * NotificacionesSection (rc46) — wrapper del tab "Notificaciones" en Ajustes.
 *
 * Solo "Grupos" como punto de control admin. Decisión rc46 de Alex:
 *   - Quitado sub-tab "Mis notificaciones" (self-service por user) — riesgo de
 *     que cualquier user se mueva el flujo.
 *   - Quitado sub-tab "Topics × Usuarios" (bulk assign) — mismo riesgo de
 *     desmadre si admin lo mueve mal.
 *   - El modelo único: solo grupos. Admin crea/edita grupos, les asigna topics
 *     y miembros. TODO el control de notificaciones pasa por aquí.
 *
 * Sub-tabs eliminados:
 *   - MisNotificacionesSubtab.tsx (borrado en rc46)
 *   - TopicsSubtab.tsx (borrado en rc46)
 */
import { GruposSubtab } from "./notif/GruposSubtab";
import { PushDispositivoCard } from "./notif/PushDispositivoCard";
import { InstalarAppCard } from "./notif/InstalarAppCard";

export function NotificacionesSection() {
  return (
    <div className="flex flex-col gap-3">
      {/* rc135 — Web Push por dispositivo (sustituye a la app iOS) */}
      <InstalarAppCard />
      <PushDispositivoCard />
      <p className="text-xs text-muted-foreground">
        Crea grupos de notificaciones, asígnales topics (pagos, tickets, cobranza, sistema)
        y agrega los usuarios que recibirán los push. El asignado de un ticket SIEMPRE
        recibe su notificación; los miembros del grupo reciben además todos los del topic.
      </p>
      <GruposSubtab />
    </div>
  );
}
